import { readStoreGroup, writeStoreGroup } from "@/schemas/storeGroup";
import {
  readStoreGroupMember,
  writeStoreGroupMember,
} from "@/schemas/storeGroupMember";
import { z } from "@/zod";

/**
 * Data Transfer Object (DTO) for StoreGroup
 * Maps directly from API schema definitions in src/schemas/storeGroup.ts
 *
 * The DTO layer ensures type safety by validating API responses against
 * the same schemas used by domain types. This avoids maintaining duplicate
 * schema definitions.
 *
 * DTO vs Domain Model:
 * - DTO: Represents API contract (what API returns)
 * - Domain: Represents business logic (ReadStoreGroup, WriteStoreGroup from types)
 *
 * In this case, they're the same because schemas are shared.
 */

// Re-export API schemas as DTO schemas (they are identical)
export const StoreGroupDTOSchema = readStoreGroup;
export const StoreGroupListDTOSchema = readStoreGroup.array();
export const CreateStoreGroupDTOSchema = writeStoreGroup;
export const UpdateStoreGroupDTOSchema = writeStoreGroup;

// Re-export store member schemas
export const StoreGroupMemberDTOSchema = readStoreGroupMember;
export const StoreGroupMemberListDTOSchema = readStoreGroupMember.array();
export const WriteStoreGroupMemberDTOSchema = writeStoreGroupMember;

// Type inference from schemas (same as domain types, by design)
export type StoreGroupDTO = z.infer<typeof StoreGroupDTOSchema>;
export type CreateStoreGroupDTO = z.infer<typeof CreateStoreGroupDTOSchema>;
export type UpdateStoreGroupDTO = z.infer<typeof UpdateStoreGroupDTOSchema>;
export type StoreGroupMemberDTO = z.infer<typeof StoreGroupMemberDTOSchema>;
export type WriteStoreGroupMemberDTO = z.infer<
  typeof WriteStoreGroupMemberDTOSchema
>;
